var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrainimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "cache-id": "2c24e097dd3046bbbd59277576815f83",
    id: "eHmPXAzwb6U1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "180 -200 300 700",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eHmPXAzwb6U2",
    transform: "translate(5.000008 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M297.774907,315.150284q27.225101,4.901535,27.225101-11.592198t-.000001-21.991644q3.406118-18.849981-17.800111-13.35207",
    transform: "translate(.000003 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,268.214372q5.916318-1.091062,5.458163-9.659256t0-10.631185q1.658403-18.217907-18.258264-18.217907",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.700557,233.824196q4.642709,2.08922,4.642709-9.285418c0-11.374638,3.864242-38.227886-14.72673-40.30886s-41.897883,2.080975-39.816909,15.399209",
    transform: "translate(.000001 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.804419,200.487752q1.138505-15.369803-10.815786-11.385039c-11.954291,3.984764-20.493069,10.815787-23.339329,17.077558s1.138503,6.831022,8.538778,8.538778",
    transform: "translate(.000001 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.798856,214.891969q-13.273781-5.688762-17.337183.270894c-4.063402,5.959656-21.671479,29.527389-23.29684,35.757939q-1.625361,6.23055,6.772337,5.417869l10.293952.541786",
    transform: "translate(.000001 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.418443,256.338672h-11.919313q-6.772338-2.167147-9.481273,8.126805t-6.78042,26.760127q-.849154,8.066971,5.09493,9.128415t20.167428,1.273731",
    transform: "translate(.000002 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.874449,302.28306q-5.53594,1.509802-5.032673,7.800643c.503267,6.290841-1.43885,32.318276,1.61069,51.293191s11.181647,27.107021,15.2477,28.123535s24.057482-2.371864,25.073995-2.710702-4.404891,1.016514,4.066053-.677675",
    transform: "translate(0 0.000001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.249852,388.434239q-23.269395,3.650103-13.231617,20.531821c10.037778,16.881718,23.725658,27.832021,31.025861,26.919496s15.056667-6.843939,18.706769-14.600405",
    transform: "translate(.000001 0.000001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.667976,420.897672q-18.342218,22.354578-4.01236,24.074161c14.329858,1.719583,15.476247,5.731942,34.964853,1.719582q19.488606-4.01236,10.890692-17.769023l-6.878332-13.183469",
    transform: "translate(0 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.925606,419.178089q10.890693,28.08652,19.488607,13.183469t6.216274-29.23321c-2.33462-8.004057-5.53238-13.750744-5.836439-16.692214",
    transform: "translate(-1.71958-2.292778)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.377132,385.359625q17.195829,0,16.622635-11.463886t0-28.659715",
    transform: "translate(-1.146388-.573193)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.658925,345.344516q2.294402-29.368345-10.095369-28.909465",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(-.769095 0.010029-.014803-1.135147 609.464731 769.056762)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.692609-.144475 0.166494 0.798166-71.532065 161.556354)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.528269 0.321408-.350497 0.576081 192.669366 38.033102)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.547833-.836588 0.836588 0.547833-243.390593 581.23412)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "translate(-200.909771 30.352572)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(-.49032-.451949 0.502377-.545029 270.422366 634.012792)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.370361-.500427 0.598249 0.442758-108.513664 312.318095)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.273792 0.961789-.961789 0.273792 442.291478-204.85679)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(-.980234 0.197841-.197841-.980234 723.853702 546.214547)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "translate(-144.813448-55.402622)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(0-1 1 0-14.508171 732.593755)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.142975,268.214372l-26.938919-1.165666q-10.310623,2.137595-10.310623-8.49359",
    transform: "translate(.000001 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.174485,248.960198q-5.300833-26.822417-25.033602-24.100655",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.878291-.478127 0.478127 0.878291-241.270871 149.345123)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.082142,301.692619q33.028151-1.295221,34.323372,19.428324",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68672,301.753827q-4.98964-23.796745,23.029108-21.493834",
    transform: "translate(.000001 0.000001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.192908,257.443495q2.84369-15.030937-9.343556-14.218454",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.317546,257.490233q-17.186981,11.369848-17.980226,17.71581",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.754696,384.138929c0-.334523-16.72615,3.010707-23.082087-2.007138s-13.380922-6.690461-15.053537-1.672616q-1.672615,5.017845-2.007138,10.370212",
    transform: "translate(2.007139 0.334525)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.295257,378.452038q-11.373782-17.395198-35.793962-8.028553t-21.743996-27.096364",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.953596,390.160343q-6.355938,23.751135-24.754703,15.053536",
    transform: "translate(-.334523 0.669046)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.173835,346.690819q15.607799,23.585119,32.602959,1.04052",
    transform: "translate(0 5.417754)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.116176,415.991604q-2.965678-22.407339,24.384457-14.828386",
    transform: "translate(0 0.000001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 653.348573 0.359574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.774907,315.150284q27.225101,4.901535,27.225101-11.592198t-.000001-21.991644q3.406118-18.849981-17.800111-13.35207",
    transform: "translate(.000003 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,268.214372q5.916318-1.091062,5.458163-9.659256t0-10.631185q1.658403-18.217907-18.258264-18.217907",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.700557,233.824196q4.642709,2.08922,4.642709-9.285418c0-11.374638,3.864242-38.227886-14.72673-40.30886s-41.897883,2.080975-39.816909,15.399209",
    transform: "translate(.000001 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.804419,200.487752q1.138505-15.369803-10.815786-11.385039c-11.954291,3.984764-20.493069,10.815787-23.339329,17.077558s1.138503,6.831022,8.538778,8.538778",
    transform: "translate(.000001 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.798856,214.891969q-13.273781-5.688762-17.337183.270894c-4.063402,5.959656-21.671479,29.527389-23.29684,35.757939q-1.625361,6.23055,6.772337,5.417869l10.293952.541786",
    transform: "translate(.000001 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.418443,256.338672h-11.919313q-6.772338-2.167147-9.481273,8.126805t-6.78042,26.760127q-.849154,8.066971,5.09493,9.128415t20.167428,1.273731",
    transform: "translate(.000002 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.874449,302.28306q-5.53594,1.509802-5.032673,7.800643c.503267,6.290841-1.43885,32.318276,1.61069,51.293191s11.181647,27.107021,15.2477,28.123535s24.057482-2.371864,25.073995-2.710702-4.404891,1.016514,4.066053-.677675",
    transform: "translate(0 0.000001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.249852,388.434239q-23.269395,3.650103-13.231617,20.531821c10.037778,16.881718,23.725658,27.832021,31.025861,26.919496s15.056667-6.843939,18.706769-14.600405",
    transform: "translate(.000001 0.000001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.667976,420.897672q-18.342218,22.354578-4.01236,24.074161c14.329858,1.719583,15.476247,5.731942,34.964853,1.719582q19.488606-4.01236,10.890692-17.769023l-6.878332-13.183469",
    transform: "translate(0 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.925606,419.178089q10.890693,28.08652,19.488607,13.183469t6.216274-29.23321c-2.33462-8.004057-5.53238-13.750744-5.836439-16.692214",
    transform: "translate(-1.71958-2.292778)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.377132,385.359625q17.195829,0,16.622635-11.463886t0-28.659715",
    transform: "translate(-1.146388-.573193)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.658925,345.344516q2.294402-29.368345-10.095369-28.909465",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(-.769095 0.010029-.014803-1.135147 609.464731 769.056762)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.692609-.144475 0.166494 0.798166-71.532065 161.556354)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.528269 0.321408-.350497 0.576081 192.669366 38.033102)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.547833-.836588 0.836588 0.547833-243.390593 581.23412)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "translate(-200.909771 30.352572)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(-.49032-.451949 0.502377-.545029 270.422366 634.012792)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.370361-.500427 0.598249 0.442758-108.513664 312.318095)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.273792 0.961789-.961789 0.273792 442.291478-204.85679)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(-.980234 0.197841-.197841-.980234 723.853702 546.214547)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "translate(-144.813448-55.402622)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(0-1 1 0-14.508171 732.593755)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.142975,268.214372l-26.938919-1.165666q-10.310623,2.137595-10.310623-8.49359",
    transform: "translate(.000001 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.174485,248.960198q-5.300833-26.822417-25.033602-24.100655",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.706882,302.423699c7.550951,13.695293,22.531567,12.630833,30-.140638",
    transform: "matrix(.878291-.478127 0.478127 0.878291-241.270871 149.345123)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.082142,301.692619q33.028151-1.295221,34.323372,19.428324",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68672,301.753827q-4.98964-23.796745,23.029108-21.493834",
    transform: "translate(.000001 0.000001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.192908,257.443495q2.84369-15.030937-9.343556-14.218454",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.317546,257.490233q-17.186981,11.369848-17.980226,17.71581",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.754696,384.138929c0-.334523-16.72615,3.010707-23.082087-2.007138s-13.380922-6.690461-15.053537-1.672616q-1.672615,5.017845-2.007138,10.370212",
    transform: "translate(2.007139 0.334525)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.295257,378.452038q-11.373782-17.395198-35.793962-8.028553t-21.743996-27.096364",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.953596,390.160343q-6.355938,23.751135-24.754703,15.053536",
    transform: "translate(-.334523 0.669046)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.173835,346.690819q15.607799,23.585119,32.602959,1.04052",
    transform: "translate(0 5.417754)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.116176,415.991604q-2.965678-22.407339,24.384457-14.828386",
    transform: "translate(0 0.000001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "eHmPXAzwb6U81",
    width: 2,
    height: 2,
    rx: 0,
    ry: 0,
    transform: "matrix(5 0 0 5 326.781094 187.402085)",
    fill: "#d396ed",
    fillOpacity: 0,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "eHmPXAzwb6U82",
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(330.967757-75)",
    fill: "#d396ed",
    fillOpacity: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "eHmPXAzwb6U83",
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(330.967757-75)",
    fill: "#d396ed",
    fillOpacity: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "eHmPXAzwb6U84",
    width: 4.651293,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "matrix(1.07497 0 0 1 330.060844-75)",
    fill: "#d396ed",
    fillOpacity: 0
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "eHmPXAzwb6U85",
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(330.967757-75)",
    fill: "#d396ed",
    fillOpacity: 0
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "eHmPXAzwb6U86",
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(330.967757-75)",
    fill: "#d396ed",
    fillOpacity: 0
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "eHmPXAzwb6U87",
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(330.967757-75)",
    fill: "#d396ed",
    fillOpacity: 0
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "eHmPXAzwb6U88",
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(330.967757-75)",
    fill: "#d396ed",
    fillOpacity: 0
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "eHmPXAzwb6U89",
    width: 5,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "translate(330.967757-75)",
    fill: "#d396ed",
    fillOpacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainimation);
export default __webpack_public_path__ + "static/media/Brainimation.262f6cef03bef4f11a9ccf6266a79528.svg";
export { ForwardRef as ReactComponent };